"use client";

import type React from "react";

export type BlockGapScale = "xs" | "sm" | "md" | "lg";

export interface BlockGapProps {
  size?: BlockGapScale; // preset scale
  responsive?: { base: string; md?: string; lg?: string }; // custom responsive classes (height or padding), e.g., { base: "h-10", md: "h-14" } or { base: "py-10", md: "py-14" }
  padding?: { base: string; md?: string; lg?: string }; // alias for custom responsive padding (e.g., { base: "py-10", md: "py-14" })
  className?: string;
}

// Maps the scale to height classes (mobile-first)
const scaleToHeight = (scale: BlockGapScale): string => {
  switch (scale) {
    case "xs":
      return "h-8 md:h-12"; // ~py-8/12 equivalent as a spacer block
    case "sm":
      return "h-12 md:h-16";
    case "md":
      return "h-20 md:h-24";
    case "lg":
      return "h-24 md:h-28";
    default:
      return "h-20 md:h-24";
  }
};

const BlockGap: React.FC<BlockGapProps> = ({
  size = "md",
  responsive,
  padding,
  className = "",
}) => {
  // Prefer explicit padding prop if provided; fall back to responsive; otherwise use size presets
  const r = padding ?? responsive;
  const classes = r
    ? [r.base || "", r.md ? `md:${r.md}` : "", r.lg ? `lg:${r.lg}` : ""]
        .filter(Boolean)
        .join(" ")
    : scaleToHeight(size);

  return (
    <div
      className={`w-full ${classes} ${className}`}
      aria-hidden="true"
      role="presentation"
    />
  );
};

export default BlockGap;
